import { inject, Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  snackBar = inject(MatSnackBar)
  translateService = inject(TranslateService)

  show(textKey: string, params: Record<string, string | number> = {}, actionTextKey: string = 'COMMON.DISMISS') {
    const text = this.translateService.instant(textKey, params)
    const actionText = this.translateService.instant(actionTextKey)
    this.snackBar.open(text, actionText, { duration: 10000 })
  }

  showRaw(text: string, actionTextKey: string = 'COMMON.DISMISS') {
    const actionText = this.translateService.instant(actionTextKey)
    this.snackBar.open(text, actionText, { duration: 10000 })
  }
}
